// App.tsx — the route table. Chrome lives in layout/AppLayout; each route is its own
// component in routes/. App state is provided by AppProvider.
import { Routes, Route } from 'react-router-dom';

import { AppProvider } from '@/state/AppProvider';
import { AppLayout } from '@/layout/AppLayout';
import ReferenceRoute from '@/routes/ReferenceRoute';
import AgentsRoute from '@/routes/AgentsRoute';
import UseCasesRoute from '@/routes/UseCasesRoute';
import SimulatorRoute from '@/routes/SimulatorRoute';
import ApiLandingRoute from '@/routes/ApiLandingRoute';
import ApiAgreementRoute from '@/routes/ApiAgreementRoute';
import OnboardingRoute from '@/routes/OnboardingRoute';
import SignInRoute from '@/routes/SignInRoute';
import SignInCallbackRoute from '@/routes/SignInCallbackRoute';
import DashboardRoute from '@/routes/DashboardRoute';
import AddAccountRoute from '@/routes/AddAccountRoute';
import VerifyAccountRoute from '@/routes/VerifyAccountRoute';
import WelcomeRoute from '@/routes/WelcomeRoute';
import NotFoundRoute from '@/routes/NotFoundRoute';
import { ProtectedRoute } from '@/routes/ProtectedRoute';

export const App = () => {
  return (
    <AppProvider>
      <Routes>
        {/* Standalone, chrome-free business-facing flows (opened via a generated link). */}
        <Route path="/accounts/add" element={<AddAccountRoute />} />
        <Route path="/accounts/verify" element={<VerifyAccountRoute />} />
        <Route path="/welcome" element={<WelcomeRoute />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<ApiLandingRoute />} />
          <Route path="/api-agreement" element={<ApiAgreementRoute />} />
          <Route path="/reference" element={<ReferenceRoute />} />
          <Route path="/reference/:section" element={<ReferenceRoute />} />
          <Route path="/use-cases" element={<UseCasesRoute />} />
          <Route path="/use-cases/:id" element={<UseCasesRoute />} />
          <Route path="/agents" element={<AgentsRoute />} />
          <Route path="/simulator" element={<SimulatorRoute />} />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute mode="authed">
                <OnboardingRoute />
              </ProtectedRoute>
            }
          />
          <Route path="/signin" element={<SignInRoute />} />
          <Route path="/signin/callback" element={<SignInCallbackRoute />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute mode="app">
                <DashboardRoute />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/:view"
            element={
              <ProtectedRoute mode="app">
                <DashboardRoute />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/:view/:id"
            element={
              <ProtectedRoute mode="app">
                <DashboardRoute />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFoundRoute />} />
        </Route>
      </Routes>
    </AppProvider>
  );
};
